import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiButtonPluginKey = new PluginKey('aiExperienceAIButton');
